import React, { useState, useEffect } from 'react';
import "./EndingScreen.css";
import { Link } from "react-router-dom";

function EndingScreen({ ending, pointsGained, setPlayerPoints }) {

    const [isVictory, setIsVictory] = useState(false);
    const [userPoints, setUserPoints] = useState(parseInt(localStorage.getItem("points")) || 0);
    const [gainedPoints, setGainedPoints] = useState(`+${pointsGained}`);

    useEffect(() => {
        if (ending === "VICTORY") {
            const localStorage = window.localStorage;
            const playerPointsSum = parseInt(userPoints + pointsGained);
            localStorage.setItem("points", playerPointsSum);
            setPlayerPoints(playerPointsSum);
            setIsVictory(true);
        }
    }, []);

    const addPointsAnim = (event) => {
        // Rappel : la fonction se lance à la fin de l'animation
        let pointsAway = 1;
        const anim = setInterval(() => {
            let points = userPoints + pointsAway;
            let pointsGained = gainedPoints - pointsAway;
            if (pointsGained < 0) {
                clearInterval(anim);
                setGainedPoints("pts");
            } else {
                pointsAway++;
                setUserPoints(points);
                setGainedPoints(`+${pointsGained}`);
                if (Math.random() < 0.1) new Audio(require("./point_effect.mp3")).play().catch(err => {throw err});
            }
        }, 3);
    }

    return (
        <div className="ending-screen">
            <div className="ending-info">
                <h1>{ending}</h1>
                    { isVictory && 
                    <h2 className="victory-points">
                        {userPoints} 
                        <span className="gained-points" onAnimationEnd={addPointsAnim}>
                            {gainedPoints}
                        </span>
                    </h2>}
                <img src={`http://www.pokestadium.com/sprites/xy/${isVictory ? "ludicolo" : "magikarp"}.gif`} alt="" />
                <Link className="playAgainBtn" to="/show-elements">Play Again!</Link>
                {isVictory && <audio src={require("./LeafGreen.mp3")} autoPlay></audio>}
            </div>
        </div>
    )
}

export default EndingScreen;
